import React, { ReactElement } from 'react';
import Page from '../../ds/components/Page/Page';

const LoadingRoute = (): ReactElement => {
  return <Page preloading={true} noNav />;
};

export default LoadingRoute;
